import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import './input.css';
import Data, {DataAPi} from "./variable/dataVariable.js";

export default function Input() {
    const navigate = useNavigate();
    const {id} = useParams()

    const [values, setValues] = useState({
        namaBarang: '',
        merek: '',
        type: '',
        warna: '',
        bahan: '',
        kategori: '',
        kategoriCode: '',
        tanggalBeli: '',
        kondisi: '',
        jumlahBarang: '',
        hargaSatuan: '',
        tahunAnggaran: '',
        spesifikasi: '',
        jenisAset: '',
        gedung: '',
        gedungCode: '',
        ruangan: '',
        ruanganCode: '',
        isiSilinder: '',
        nomorRangka: '',
        nomorMesin: '',
        nomorBPKB: '',
        bahanBakar: '',
        nomorInventaris: '',
    })
    
    const [setRuang, saveSetRuang] = useState("0");

    useEffect(() => {
        getAset();
    },[]);

    const getAset = async() => {
        const res = await axios.get(DataAPi.urlGetOne + id);
        setValues({
            namaBarang: res.data.namaBarang,
            merek: res.data.merek,
            type: res.data.type,
            warna: res.data.warna,
            bahan: res.data.bahan,
            kategori: res.data.kategori,
            kategoriCode: res.data.kategoriCode,
            tanggalBeli: res.data.tanggalBeli,
            kondisi: res.data.kondisi,
            jumlahBarang: res.data.jumlahBarang,
            hargaSatuan: res.data.hargaSatuan,
            tahunAnggaran: res.data.tahunAnggaran,
            spesifikasi: res.data.spesifikasi,
            jenisAset: res.data.jenisAset,
            gedung: res.data.gedung,
            gedungCode: res.data.gedungCode,
            ruangan: res.data.ruangan,
            ruanganCode: res.data.ruanganCode,
            isiSilinder: res.data.isiSilinder,
            nomorRangka: res.data.nomorRangka,
            nomorMesin: res.data.nomorMesin,
            nomorBPKB: res.data.nomorBPKB,
            bahanBakar: res.data.bahanBakar,
            nomorInventaris: res.data.nomorInventaris,
        })
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        axios.put(DataAPi.urlPutUpdate + id, values)
        .then(res => {
            navigate("/inventaris/rekapitulasi", {replace: true})
            console.log(res)
        })
        .catch(err => console.log(err))
    }
    return (
        <div className="container-sm py-5">
            <div className="text-center pb-4">
                <h2>Edit Aset</h2>
            </div>
            <form onSubmit={handleSubmit} className="row g-3 p-5 bg-light shadow input-group-lg fw-semibold rounded">
                <div className="col-md-12 border-bottom border-2 border-success">
                    <h4>Deskripsi Aset</h4>
                </div>
                <div className="col-md-6">
                    <label className="form-label fs-6" for="InputNamaBarang">Nama Barang</label>
                    <input className="form-control mb-4 shadow-sm" type="text" name="InputNamaBarang" value={values.namaBarang} required onChange={e => setValues({...values, namaBarang: e.target.value})}></input>
                </div>
                <div className="col-md-6">
                    <label className="form-label fs-6" for="InputMerek">Merek</label>
                    <input className="form-control mb-4 shadow-sm" type="text" name="InputMerek" value={values.merek} required onChange={e => setValues({...values, merek: e.target.value})}></input>
                </div>
                <div className="col-md-6">
                    <label className="form-label fs-6" for="InputType">Type</label>
                    <input className="form-control mb-4 shadow-sm" type="text" name="InputType" value={values.type} required onChange={e => setValues({...values, type: e.target.value})}></input>
                </div>
                <div className="col-md-6">
                    <label className="form-label fs-6" for="InputWarna">Warna</label>
                    <input className="form-control mb-4 shadow-sm" type="text" name="InputWarna" value={values.warna} required onChange={e => setValues({...values, warna: e.target.value})}></input>
                </div>
                <div className="col-md-6">
                    <label className="form-label fs-6" for="InputBahan">Bahan</label>
                    <input className="form-control mb-4 shadow-sm" type="text" name="InputWarna" value={values.bahan} required onChange={e => setValues({...values, bahan: e.target.value})}></input>
                </div>
                <div className="col-md-6">
                    <label className="form-label fs-6" for="InputGedung">kategori</label>
                    <select className="form-control mb-4 shadow-sm" value={values.kategori} required onChange={e => setValues({...values, kategori: Data.Kategori[e.target.value].data, kategoriCode: Data.Kategori[e.target.value].dataCode})}>
                        <option selected>{values.kategori}</option>
                        {
                            Data.Kategori.map((kategori, index) => {
                                return (
                                    <option value={`${index}`}>{kategori.data}</option>
                                )
                            })
                        }
                    </select>
                </div>
                <div className="col-md-2">
                    <label className="form-label fs-6" for="InputTanggalPembelian">Tanggal Pembelian</label>
                    <input className="form-control mb-4 shadow-sm" type="date" name="InputTanggalPembelian" value={values.tanggalBeli} required onChange={e => setValues({...values, tanggalBeli: e.target.value})}></input>
                </div>
                
                <div className="col-md-2">
                    <label className="form-label fs-6" for="InputKondisiBarang">Kondisi Barang</label>
                    <select className="form-control mb-4 shadow-sm" value={values.kondisi} required onChange={e => setValues({...values, kondisi: e.target.value})}>
                        <option selected>Kondisi</option>
                        <option value="Baru">Baru</option>
                        <option value="Bekas">Bekas</option>
                    </select>
                </div>

                <div className="col-md-2">
                    <label className="form-label fs-6" for="InputJumlahBarang">Jumlah Barang</label>
                    <div className="input-group flex-nowrap">
                        <input className="form-control mb-4 shadow-sm" aria-describedby="basic-addon1" type="number" min="1" name="InputJumlahBarang" value={values.jumlahBarang} required onChange={e => setValues({...values, jumlahBarang: e.target.value})}></input>
                        <span className="input-group-text mb-4" id="basic-addon1">Unit</span>
                    </div>
                    
                </div>

                <div className="col-md-3">
                    <label className="form-label fs-6" for="InputHargaSatuan">Harga Satuan</label>
                    <div className="input-group flex-nowrap">
                        <span class="input-group-text mb-4" id="basic-addon2">Rp</span>
                        <input className="form-control mb-4 shadow-sm" aria-describedby="basic-addon2" type="number" min="0" placeholder="5000000" name="InputHargaSatuan" value={values.hargaSatuan} required onChange={e => setValues({...values, hargaSatuan: e.target.value})}></input>
                    </div>
                </div>

                <div className="col-md-3">
                    <label className="form-label fs-6" for="InputTahunAnggaran">Tahun Anggaran</label>
                    <input className="form-control mb-4 shadow-sm" type="number" min="0" name="InputTahunAnggaran" value={values.tahunAnggaran} required onChange={e => setValues({...values, tahunAnggaran: e.target.value})}></input>
                </div>

                <div className="col-md-10">
                    <label className="form-label fs-6" for="InputSpesifikasi">Spesifikasi</label>
                    <textarea className="form-control mb-4 shadow-sm" type="paragraph" name="InputSpesifikasi" rows="4" value={values.spesifikasi} required onChange={e => setValues({...values, spesifikasi: e.target.value})}></textarea>
                </div>
                
                <div className="col-md-2">
                    <label className="form-label fs-6" for="InputKondisiBarang">Asal Aset</label>
                    <select className="form-control mb-4 shadow-sm" value={values.jenisAset} required onChange={e => setValues({...values, jenisAset: e.target.value})}>
                        <option selected>Pilih Asal Aset</option>
                        <option value="Pembelian">Pembelian</option>
                        <option value="Bantuan">Hibah</option>
                    </select>
                </div>
                <div className="col-md-12 border-bottom border-2 border-success">
                    <h4>Lokasi Aset</h4>
                </div>
                <div className="col-md-6">
                    <label className="form-label fs-6" for="InputGedung">Gedung</label>
                    <select className="form-control mb-4 shadow-sm" value={values.gedung} required onChange={e => {setValues({...values, gedung: Data.Gedung[e.target.value].data, gedungCode: Data.Gedung[e.target.value].dataCode}); saveSetRuang(e.target.value)}}>
                        <option selected>{values.gedung}</option>
                        {
                            Data.Gedung.map((gedung, index) => {
                                return (
                                    <option value={`${index}`}>{gedung.data}</option>
                                )
                            })
                        }
                    </select>
                </div>
                <div className="col-md-6">
                    <label className="form-label fs-6" for="InputRuangan">Ruangan</label>
                    <select className="form-control mb-4 shadow-sm" value={values.ruangan} required onChange={e => setValues({...values, ruangan: Data.Ruangan[setRuang][e.target.value].data, ruanganCode: Data.Ruangan[setRuang][e.target.value].dataCode})}>
                        <option selected>{values.ruangan}</option>
                        {
                            Data.Ruangan[setRuang].map((ruangan, index) => {
                                return (
                                    <option value={`${index}`}>{ruangan.data}</option>
                                )
                            })
                        }
                    </select>
                </div>
                <div className="col-md-12 border-bottom border-2 border-success">
                    <h4>Jenis Aset</h4>
                </div>
                <div className="col-md-12">
                    <input className="form-check-input m-2" type="checkbox" id="a" style={{width: "20px", height: "20px"}} />
                        <label htmlFor="a" className="a m-2" for="a">
                            Centang Jika Aset Merupakan Kendaraan Bermotor
                        </label>
                    <div className="showUp">
                        <div className="col-md-6">
                            <label className="form-label fs-6" for="InputIsiSilinder">Isi Silinder</label>
                            <input className="form-control mb-4 shadow-sm" type="number" placeholder="1500" value={values.isiSilinder} name="InputIsiSilinder" onChange={e => setValues({...values, isiSilinder: e.target.value})}></input>
                        </div>
                        <div className="col-md-6">
                            <label className="form-label fs-6" for="InputNomorRangka">Nomor Rangka</label>
                            <input className="form-control mb-4 shadow-sm" type="text" name="InputNomorRangka" value={values.nomorRangka} onChange={e => setValues({...values, nomorRangka: e.target.value})}></input>
                        </div>
                        <div className="col-md-6">
                            <label className="form-label fs-6" for="InputNomorMesin">Nomor Mesin</label>
                            <input className="form-control mb-4 shadow-sm" type="text" name="InputNomorMesin" value={values.nomorMesin} onChange={e => setValues({...values, nomorMesin: e.target.value})}></input>
                        </div>
                        <div className="col-md-6">
                            <label className="form-label fs-6" for="InputNomorBPKB">Nomor BPKB</label>
                            <input className="form-control mb-4 shadow-sm" type="text" name="InputNomorBPKB" value={values.nomorBPKB} onChange={e => setValues({...values, nomorBPKB: e.target.value})}></input>
                        </div>
                        <div className="col-md-6">
                            <label className="form-label fs-6" for="InputBahanBakar">Bahan Bakar</label>
                            <input className="form-control mb-4 shadow-sm" type="text" name="InputBahanBakar" value={values.bahanBakar} onChange={e => setValues({...values, bahanBakar: e.target.value})}></input>
                        </div>
                        </div>
                    </div>
                <div className="col-md-6 row g-2">
                    <button type="Submit" className="btn btn-success">Update</button>
                    <Link to="/inventaris/rekapitulasi" className="btn btn-secondary">Kembali</Link>
                </div>

            </form>
        </div>
    );
}
